<template>
  <div v-if="projectId" class="project-menu-container">
    <a-dropdown placement="bottomLeft">
      <div class="project-selector">
        <a-avatar class="project-avatar" shape="square" :size="24" :src="currentProject.logo" />
        <div class="project-info">
          <span class="project-name">{{ currentProject.name }}</span>
          <a-icon class="dropdown-icon" type="down" />
        </div>
      </div>
      <a-menu slot="overlay" class="project-dropdown">
        <a-menu-item v-for="(project, i) in projects" :key="i" @click="toProject(project)">
          <div class="project-item">
            <a-avatar shape="square" :size="20" :src="project.logo" />
            <span class="item-name">{{ project.name }}</span>
          </div>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import { projectDetail, projectInvolvedList } from '@/api/project/project';
import { listToTree } from '@/utils/utils';

export default {
  name: 'ProjectMenu',
  data() {
    return {
      projects: [],
      projectId: parseInt(this.$route.params.project_id) || null,
      currentProject: {}
    };
  },
  watch: {
    projectId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getProjectDetail(val);
        }
      }
    }
  },
  created() {
    this.getProjectList();
  },
  methods: {
    // 获取项目列表
    getProjectList() {
      projectInvolvedList({})
        .then(res => {
          this.projects = res.data.items;
        })
        .catch(err => {
          console.error('Failed to load project list:', err);
          this.$message.error('加载项目列表失败');
        });
    },
    // 进入项目内
    toProject(project) {
      // 查找菜单中是否有工程中心的子菜单，如果有说明用户有系统管理权限
      this.projectId = project.id;
      for (const menu of this.$store.state.menus) {
        if (menu.code === 'page:project' && menu.children.length > 0) {
          this.$store.commit('setSideMenu', menu.children);
          const url = this.$router.resolve({
            name: this.$route.name,
            params: { project_id: project.id }
            // query: this.$route.query
          }).href;
          window.location = url;
          return;
        }
      }

      // 判断用户是否有指定项目的权限
      if (this.$store.state.routers[project.id] !== undefined) {
        this.$store.commit('setSideMenu', listToTree(this.$store.state.routers[project.id], 1));
        const url = this.$router.resolve({
          name: this.$route.name,
          params: { project_id: project.id }
          // query: this.$route.query
        }).href;
        window.location = url;
        return;
      }
      this.$message.warning('没有权限');
    },
    getProjectDetail(projectId) {
      projectDetail({ project_id: projectId })
        .then(res => {
          const data = res.data;
          this.currentProject = {
            name: data.name,
            logo: data.logo
          };
        })
        .catch(err => {
          console.error('Failed to load project detail:', err);
          this.$message.error('加载项目详情失败');
        });
    }
  }
};
</script>

<style lang="less" scoped>
.project-menu-container {
  .project-selector {
    display: flex;
    align-items: center;
    height: 48px;
    padding: 0 8px;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.3s ease;
    color: rgba(0, 0, 0, 0.65);
    min-width: 120px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
      color: rgba(0, 0, 0, 0.85);
    }

    .project-avatar {
      margin-right: 8px;
      transition: border-color 0.3s ease;
    }

    .project-info {
      display: flex;
      align-items: center;
      flex: 1;

      .project-name {
        font-size: 14px;
        font-weight: 500;
        margin-right: 6px;
        user-select: none;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .dropdown-icon {
        font-size: 12px;
        transition: transform 0.3s ease;
      }
    }

    &:hover {
      .dropdown-icon {
        transform: rotate(180deg);
      }
    }
  }
}

.project-dropdown {
  .project-item {
    display: flex;
    align-items: center;
    padding: 4px 0;

    .ant-avatar {
      margin-right: 8px;
      border: 1px solid #f0f0f0;
    }

    .item-name {
      font-size: 14px;
      max-width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
